module.exports = __webpack_public_path__ + "media/assets/icons/pencil-white-ecd60bd8cf8037199a01610d60a23ddc.svg";